import CardMainTile from '@/organisms/CardMainTile';
import FoilerTile from 'components/template/Cards/details/components/CollectionTab/FoilerTile';
import VariantsTile from 'components/template/Cards/details/components/CollectionTab/VariantsTile';
import useUserApi from 'hooks/UserApi/useUserApi';

import { CARD_TYPE_API_REF } from 'types/modifiers/references';
import CollectionTile from './CollectionTile';
import { CardDetailsWithStats } from 'hooks/queries/cards/useCardsDetailsApi';
import CardHistory from '@/organisms/CardHistory';

const CollectionTab = ({ card }: { card: CardDetailsWithStats }) => {
  const { user } = useUserApi();

  if (!card.reference) {
    return null;
  }

  return (
    <>
      {card.cardType?.reference !== CARD_TYPE_API_REF.FOILER && <CardMainTile card={card} />}
      {user && <CollectionTile card={card} />}
      {card.reference && <VariantsTile reference={card.reference} />}
      {card.cardType?.reference === CARD_TYPE_API_REF.FOILER ? (
        <FoilerTile />
      ) : (
        <CardHistory cardRef={card.reference} />
      )}
    </>
  );
};

export default CollectionTab;
